<template>
  <transition name="modal">
    <div class="modalMask" v-show="show">
      <div class="modalWrapper" @click.self="handleClick">
        <div class="modalContainer">
          <div class="modalHeader">
            <h1>{{ $t('shop.share_B12') }}</h1>
          </div>
          <div v-if="rewardUse" class="modalBody">
            <h2>리워드 프로그램</h2>
            <p>
              링크 공유 후 친구가 구매 후
              <br />
              쿠폰 사용한 금액의 {{ rewardRate }}%를
              <br />
              플레이포인트로 적립해드립니다.
              <br />
              (월 최대
              {{
                $t('common.unit_with_value.unit_currency', {
                  value: maxRewardPerMonth.addComma()
                })
              }})
            </p>
            <p>
              동일한 상품에 대해 한 명의 친구에게
              <br />
              적립 받을 수 있는 수량은 1개입니다.
              <br />
              한 명의 친구가 여러 개 구매하더라도
              <br />
              1개 금액에 대해서만 적립됩니다.
            </p>
          </div>
          <div class="modalFooter">
            <span v-if="isJp" class="jp">
              <button
                type="button"
                class="btLine shareButton"
                @click="shareLine()"
              >
                <span class="accessibilityHide">페이스북 공유하기</span>
              </button>
              <button type="button" class="btX shareButton" @click="shareX()">
                <span class="accessibilityHide">카카오톡 공유하기</span>
              </button>
              <button
                v-if="isClipboardSupported"
                type="button"
                class="btClipboard shareButton"
              >
                <span class="accessibilityHide">
                  {{ $t('shop.copy_url_B13') }}
                </span>
              </button>
            </span>
            <span v-else>
              <button type="button" class="btKakao" @click="kakaoShare()">
                <span class="accessibilityHide">카카오톡 공유하기</span>
              </button>
              <button type="button" class="btFacebook" @click="facebookShare()">
                <span class="accessibilityHide">페이스북 공유하기</span>
              </button>
              <button
                v-if="isClipboardSupported"
                type="button"
                class="btClipboard"
              >
                <span class="accessibilityHide">
                  {{ $t('shop.copy_url_B13') }}
                </span>
              </button>
            </span>
            <button class="btClose" @click.self="handleClick">
              <span class="accessibilityHide">공유하기 레이어 닫기</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { loginCheckWrap, getBaseInfo } from '@/utils'
import ClipboardJS from 'clipboard'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    shareUrl: {
      type: String,
      default: ''
    },
    rewardRate: {
      type: Number,
      default: 0
    },
    rewardUse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clipboard: null,
      nationPath: getBaseInfo().nationPath
    }
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    handleClick() {
      this.$emit('shareModalToggle')
    },
    rewardUseCheck(func) {
      if (this.rewardUse) {
        loginCheckWrap(() => {
          func()
        })
      } else {
        func()
      }
    },
    kakaoShare() {
      this.rewardUseCheck(() => {
        Kakao.Link.sendScrap({
          requestUrl: this.addCountryCodeToUrl(this.shareUrl, this.nationPath),
          installTalk: true
        })
      })
    },
    facebookShare() {
      this.rewardUseCheck(() => {
        FB.ui(
          {
            method: 'share',
            href: this.addCountryCodeToUrl(this.shareUrl, this.nationPath)
          },
          function(response) {}
        )
      })
    },
    shareLine() {
      window.open(
        'https://line.me/R/share?text=' +
          encodeURIComponent(
            this.addCountryCodeToUrl(this.shareUrl, this.nationPath)
          ),
        '_blank'
      )
    },
    shareX() {
      window
        .open(
          'https://twitter.com/intent/tweet?text=' +
            encodeURIComponent(
              this.addCountryCodeToUrl(this.shareUrl, this.nationPath)
            ),
          '_blank'
        )
        .focus()
    },
    addCountryCodeToUrl(url, countryCode) {
      try {
        // URL 객체를 생성
        const urlObj = new URL(url)

        const path = urlObj.pathname

        const newPath = countryCode ? `/${countryCode}${path}` : path

        urlObj.pathname = newPath

        return urlObj.toString()
      } catch (error) {
        console.error('Invalid URL:', error)
        return null
      }
    }
  },
  computed: {
    ...mapGetters('main', ['maxRewardPerMonth']),
    isClipboardSupported() {
      return ClipboardJS.isSupported()
    },
    isJp() {
      return this.nationPath === 'jp'
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isClipboardSupported) {
        this.clipboard = new ClipboardJS('.btClipboard', {
          text: () => this.addCountryCodeToUrl(this.shareUrl, this.nationPath)
        })
        this.clipboard.on('success', e => {
          this.rewardUseCheck(() => {
            this.openModal({
              type: 'alert',
              message: this.$t('shop.url_copied_message_B14')
            })
          })
        })
        this.clipboard.on('error', e => {
          loginCheckWrap(() => {
            this.openModal({
              type: 'alert',
              message: 'URL 복사에 실패하였습니다.'
            })
          })
        })
      }
    })
  },
  destroyed() {
    if (this.clipboard) this.clipboard.destroy()
  }
}
</script>

<style lang="scss">
.modalShare {
  .modalContainer {
    position: relative;
    width: 260px;
    max-width: 260px;
    padding: 15px 35px;
    .modalHeader {
      height: 30px;
    }
    h1 {
      font-size: 15px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: center;
      color: #151721;
    }
    .modalBody {
      position: relative;
      padding-top: 26px;
      &::after {
        content: '';
        position: absolute;
        top: 10px;
        left: 50%;
        display: block;
        width: 17px;
        height: 2px;
        margin-left: -8px;
        background-color: #000;
      }
      h2 {
        font-size: 13px;
        font-weight: bold;
        line-height: 1.15;
        margin-bottom: 9px;
      }
      p {
        font-size: 12px;
        line-height: 1.5;
        color: #57575c;
        & + p {
          padding-top: 7px;
        }
      }
    }
    .modalFooter {
      height: 87px;
      padding: 22px 0 15px;
      text-align: center;
    }
    button {
      display: inline-block;
      width: 50px;
      height: 50px;
      background: url('~@/assets/images/set_share.png') no-repeat 0 0;
      background-size: 50px auto;
    }
    .jp {
      .shareButton {
        background: url('~@/assets/images/set_share_jp.png') no-repeat 0 0;
        background-size: 50px auto;
      }
      .btX {
        background-position: 0 -50px;
        margin-left: 15px;
      }
      .btLine {
        background-position: 0 0;
      }
      .btClipboard {
        background-position: 0 -100px;
        margin-left: 15px;
      }
    }
    .btKakao {
      background-position: 0 0;
    }
    .btFacebook {
      background-position: 0 -50px;
      margin-left: 15px;
    }
    .btClipboard {
      background-position: 0 -100px;
      margin-left: 15px;
    }
    .btClose {
      position: absolute;
      top: 10px;
      right: 10px;
      display: block;
      width: 15px;
      height: 15px;
      background: url('~@/assets/images/set_icon.png') no-repeat -50px -1050px;
      background-color: #fff;
      background-size: 100px auto;
      margin-left: 30px;
    }
  }
}
</style>
